import { render, staticRenderFns } from "./ModalBackofficeOrcamentoParticular.vue?vue&type=template&id=db2de2c0&scoped=true"
import script from "./ModalBackofficeOrcamentoParticular.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeOrcamentoParticular.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeOrcamentoParticular.vue?vue&type=style&index=0&id=db2de2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2de2c0",
  null
  
)

export default component.exports